// extracted by css-extract-rspack-plugin
export default {"invisibleSpinButton":"V07nY"};